import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function HoverMenu({ title, options }) {
  return (
    <StyledDropdown>
      <div className="dropbtn">
        <h5>{title}</h5>
        <div className="arrow">
          <KeyboardArrowDownIcon fontSize="small" />
        </div>
      </div>
      <div className="dropdown-content">
        {options.map((option, index) => (
          <Link key={index} to={option.route}>
            {option.name}
          </Link>
        ))}
      </div>
    </StyledDropdown>
  );
}

const StyledDropdown = styled.div`
  /* The container <div> - needed to position the dropdown content */
  position: relative;
  display: inline-block;
  color: var(--text-light-color);
  /* Show the dropdown menu on hover */
  &:hover {
    .dropdown-content {
      display: block;
    }

    /* Change the background color of the dropdown button when the dropdown content is shown */
    .dropbtn {
      color: var(--primary-color);
      .arrow {
        animation: rotateArrow 0.2s ease-in-out forwards;
      }
    }
  }

  /* Dropdown Button */
  .dropbtn {
    margin-right: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    h5 {
      color: inherit;
      font-weight: 500;
      font-size: 1rem;
    }
    .arrow {
      align-self: flex-end;
      transform-origin: center 45%;
      margin-top: 4px;
    }
  }

  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    a {
      padding: 8px 16px;
      text-decoration: none;
      display: block;
      white-space: nowrap;
      &:hover {
        color: var(--primary-color);
      }
    }
  }

  @keyframes rotateArrow {
    100% {
      transform: rotate(180deg);
    }
  }
`;
